import { Button, Grid, Message } from "designSystem/index";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";

export default () => {
	return (
		<CssColumnGrid columns={1}>

			<Message
				titleText="Error message content"
				variant="error"
			/>
			<Message
				bulletPoints={["Error message content", "Error message content", "Error message content"]}
				titleText="Title for Error Message"
				variant="error"
			/>
			<Message
				description="Error message content. Error message content. Error message content. Error message content. Error message content. Error message content. Error message content. Error message content. Error message content. Error message content. Error message content. Error message content."
				titleText="Title for Error Message"
				variant="error"
			/>
			<Message
				titleText="Error message content"
				variant="error"
			>{{
					buttons: (
						<Grid
							container
							justifyContent="flex-end"
							spacing={2}
						>
							<Grid item>
								<Button design="secondary">Button</Button>
							</Grid>
							<Grid item>
								<Button design="primary">Button</Button>
							</Grid>
							<Grid item>
								<Button design="link">Dismiss</Button>
							</Grid>
						</Grid>
					),
				}}
			</Message>
			<Message
				bulletPoints={["Error message content", "Error message content", "Error message content"]}
				titleText="Error message content"
				variant="error"
			>{{
					buttons: (
						<Grid
							container
							justifyContent="flex-end"
							spacing={2}
						>
							<Grid item>
								<Button design="secondary">Button</Button>
							</Grid>
							<Grid item>
								<Button design="primary">Button</Button>
							</Grid>
							<Grid item>
								<Button design="link">Dismiss</Button>
							</Grid>
						</Grid>
					),
				}}
			</Message>

		</CssColumnGrid>
	);
};

